<div class="kpis-container" *ngIf="kpisByCategory">
  <span class="kpis-title">
    KPIs
    <span class="kpis-title-stages">
      {{ titleStages }}
    </span>
  </span>
  <div class="kpis-contents">
    <ng-container *ngFor="let kpiByCategory of kpisByCategoryArray">
      <kpi-card
        [category]="kpiByCategory.category"
        [kpis]="kpiByCategory.kpis"
        [selectedKpiKey]="selectedKpiKey"
        [tooltipsEnabled]="tooltipsEnabled"
        [keyMilestones]="keyMilestones"
        (kpiCardClicked)="onKpiCardClicked($event)"
      ></kpi-card>
    </ng-container>
  </div>
</div>
